var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__header",class:{'open': _vm.openFilter},attrs:{"id":"toggleOpenFilterButton"},on:{"click":_vm.filterClickHandler}},[_c('span',{staticClass:"filter__text labelStyleH"},[_vm._v("Filter")])])
}
var staticRenderFns = []

export { render, staticRenderFns }